import { z } from "zod";
import { validatePassword } from "./utils";

export const userSchema = z
  .object({
    auth0_user_id: z.string().optional(),
    email: z.string().email("Invalid email."),
    name: z.string().min(1, "Full name is required."),
    nickname: z.string().default(null),
    password: z
      .string()
      .optional()
      .refine((password) => !password || validatePassword(password), {
        message:
          "Password must be at least 8 characters and contain at least 3 of the following: uppercase, lowercase, digit, special character.",
      }),
    roles: z.array(z.string()).min(1, "At least one role is required."),
    permits: z.array(z.number()).optional(),
  })
  .refine(
    (data) => {
      // If creating a new user, password is required
      return !!data.auth0_user_id || !!data.password;
    },
    {
      message: "Password is required when creating a new user.",
      path: ["password"],
    }
  );
